import { useEffect, useState } from "react";
import api, { API } from "../../lib/api";
import { Download, Receipt } from "lucide-react";

export default function CustomerInvoices() {
  const [purchases, setPurchases] = useState([]);

  useEffect(() => { api.get("/customer/purchases").then((r) => setPurchases(r.data)); }, []);

  const downloadInvoice = async (type, id, invNo) => {
    const token = localStorage.getItem("gf_token");
    const r = await fetch(`${API}/invoices/${type}/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${invNo || "invoice"}.pdf`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-display text-3xl md:text-4xl">Invoices</h1>
        <p className="text-[#6B5F58] mt-1">Download invoices for your lot purchases.</p>
      </div>

      {purchases.length === 0 ? (
        <div className="gf-card p-10 text-center">
          <Receipt className="w-10 h-10 text-[#6B5F58] mx-auto mb-3" />
          <div className="font-display text-xl">No invoices yet</div>
        </div>
      ) : (
        <div className="gf-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#F8F4E9] text-xs uppercase tracking-wider text-[#6B5F58]">
              <tr>
                <th className="text-left px-4 py-3">Invoice</th>
                <th className="text-left px-4 py-3">Date</th>
                <th className="text-left px-4 py-3">Lot</th>
                <th className="text-right px-4 py-3">Amount</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {purchases.map((p) => (
                <tr key={p.id} className="border-t border-[#E8E0D2]">
                  <td className="px-4 py-3 font-mono text-xs">{p.invoice_number || "—"}</td>
                  <td className="px-4 py-3 text-xs">{(p.created_at || "").slice(0, 10)}</td>
                  <td className="px-4 py-3">{p.lot?.lot_code} · {p.lot?.name}</td>
                  <td className="px-4 py-3 text-right font-medium">₹{p.amount.toLocaleString()}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs ${p.status === "paid" ? "bg-[#FCEDED] text-[#D71921]" : "bg-amber-100 text-amber-800"}`}>{p.status}</span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    {p.status === "paid" && (
                      <button onClick={() => downloadInvoice("purchase", p.id, p.invoice_number)}
                        data-testid={`download-invoice-${p.id}`}
                        className="text-[#D71921] text-sm flex items-center gap-1 hover:underline">
                        <Download className="w-3.5 h-3.5" /> PDF
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
